import {
  ApiGetRequest,
  ApiPostRequest,
  ApiDeleteRequest,
  ApiPutRequest,
  ApiBlobGetRequest,
  ApiPostMultipart,
} from '../../../api';
import { showNotif } from '../../notification';
import moment from 'moment-mini';
export const state = {
  data: {
    title: 'File File Faktur Pajak',
    form_title: 'Form File File Faktur',
    breadcrumb: [
      {
        text: 'Dashboard',
        href: '/fin',
      },
      {
        text: 'File File Faktur',
        href: '/adm/fin/faktur-pajak/file-faktur',
        active: true,
      },
    ],
    items: [],
    total: 0,
    page: 1,
    limit: 10,
    pageOptions: [10, 25, 50, 100],
    search: '',
    sortBy: 'id_faktur_file',
    sortDesc: false,
    fields: [
      {
        key: 'created_at',
        label: 'Upload Date',
        sortable: true,
      },
      {
        key: 'no_referensi',
        label: 'Trans No',
      },
      {
        key: 'file_name',
        label: 'File Name',
      },
      {
        key: 'file_size',
        label: 'File Size',
        thStyle: {
          width: '100px',
        },
      },
      {
        key: 'file_status',
        label: 'Status',
      },
      {
        key: 'name',
        label: 'Admin',
      },
      {
        key: 'aksi',
        label: 'Aksi',
        thStyle: {
          width: '100px',
        },
      },
    ],
    detail: false,
    form: {},
  },
};

export const getters = {
  form(state) {
    return state.data.form;
  },
};

export const mutations = {
  changeFileFaktur(state, data) {
    state.data = Object.assign({}, state.data, data);
  },
};

export const actions = {
  async searchFileFaktur(context, params = null) {
    let result = await ApiGetRequest(`fin/faktur`, params);
    return !result.error ? result.data.object : [];
  },

  async uploadDocument({ commit, state }, payload) {
    commit('changeFileFaktur', {
      loadingUpload: true,
    });

    const { data } = state;
    const result = await ApiPostMultipart(`opr/upload-document`, payload);
    commit('changeFileFaktur', {
      loadingUpload: false,
    });

    if (!result.error) {
      let doc_files = data.form.doc_files || [];
      doc_files.push(result.data.object);

      commit('changeFileFaktur', {
        form: {
          ...data.form,
          doc_files,
        },
      });
    }
  },

  async uploadDocumentFileFaktur({ commit, state, dispatch }) {
    commit('changeFileFaktur', {
      loading: true,
    });

    let data_form = state.data.form;
    let result = await ApiPostRequest(`fin/faktur/upload-faktur`, data_form);
    commit('changeFileFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async getFileFakturTransaksi({ commit, state }) {
    commit('changeFileFaktur', {
      loading: true,
    });

    const { data } = state;
    let params = {
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
      start_date:
        data.form.date && data.form.date.length > 0 && data.form.date[0]
          ? moment(data.form.date[0]).format('YYYY-MM-DD')
          : '',
      end_date:
        data.form.date && data.form.date.length > 0 && data.form.date[1]
          ? moment(data.form.date[1]).format('YYYY-MM-DD')
          : '',
    };

    let result = await ApiGetRequest(`fin/faktur/show-trans`, params);
    commit('changeFileFaktur', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getListFileFaktur({ commit, state }, payload = {}) {
    commit('changeFileFaktur', {
      loading: true,
    });

    const { data } = state;
    let params = {
      ...payload,
      q: data.search,
      limit: data.limit,
      page: data.page,
      sort: data.sortBy,
      order: data.sortDesc ? 'desc' : 'asc',
    };

    let result = await ApiGetRequest(`fin/faktur/list-file-faktur`, params);
    commit('changeFileFaktur', {
      items: !result.error ? result.data.object : [],
      total: !result.error ? result.data.total : 0,
      loading: false,
    });

    return !result.error ? result.data.object : [];
  },

  async getDetailFileFaktur({ commit, state }, payload = null) {
    commit('changeFileFaktur', {
      loading: true,
    });

    const { data } = state;
    let result = await ApiGetRequest(`fin/faktur/${payload.id}`);
    commit('changeFileFaktur', {
      loading: false,
    });

    if (!result.error) {
      commit('changeFileFaktur', {
        form: {
          ...data.form,
          ...result.data.object,
        },
      });
    }

    return result.error ? false : true;
  },

  async createGenerateFileFaktur({ commit, state, dispatch }) {
    commit('changeFileFaktur', {
      loading: true,
    });

    let data_form = state.data.form;
    data_form.start_date =
      data_form.date && data_form.date.length > 0 && data_form.date[0]
        ? moment(data_form.date[0]).format('YYYY-MM-DD')
        : '';
    data_form.end_date =
      data_form.date && data_form.date.length > 0 && data_form.date[1]
        ? moment(data_form.date[1]).format('YYYY-MM-DD')
        : '';

    let result = await ApiPostRequest(`fin/faktur/generate-faktur`, data_form);
    commit('changeFileFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async updateFileFaktur({ commit, state, dispatch }, payload = null) {
    commit('changeFileFaktur', {
      loading: true,
    });

    let result = await ApiPutRequest(
      `fin/faktur/${payload.id}`,
      state.data.form
    );

    commit('changeFileFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
      });
    }

    return result.error ? false : true;
  },

  async deleteFileFaktur({ commit, dispatch }, payload = null) {
    commit('changeFileFaktur', {
      loading: true,
    });

    let result = await ApiDeleteRequest(
      `fin/faktur/file-faktur/${payload.id_faktur_file}`
    );
    commit('changeFileFaktur', {
      loading: false,
    });

    if (!result.error) {
      showNotif(dispatch, {
        message: result.data.message,
        type: 'success',
      });
    }

    return result.error ? false : true;
  },

  async downloadFileFaktur({ commit }, payload = null) {
    commit('changeFileFaktur', {
      loading: true,
    });

    let result = await ApiBlobGetRequest(
      `fin/faktur/download-excel/${payload ? payload.id_faktur_coretax : ''}`
    );

    if (result.error) {
      commit('changeFileFaktur', {
        loading: false,
      });

      return false;
    } else {
      commit('changeFileFaktur', {
        loading: false,
      });

      if (result.error) {
        return false;
      } else {
        // The actual download
        var blob = result.data;
        var link = document.createElement('a');
        link.href = window.URL.createObjectURL(blob);
        link.download = 'report_coretax.xlsx';

        document.body.appendChild(link);

        link.click();
        document.body.removeChild(link);

        return true;
      }
    }
  },
};
